import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"

import "./Fixed.scss"

function Fixed(props) {
  // ref to container
  let refDiv = React.createRef()

  const [height, setHeight] = useState(0)

  useEffect(() => {
    setHeight(refDiv.current.offsetHeight)
  }, [refDiv])
  
  return (
    <>
      <div className="c-fixed-offset" style={{height:`${height}px`}}></div>
      <div className={`c-fixed ${props.position} level${props.level} ${props.className || ''}`} id={props.id || null} ref={refDiv}>
        {props.children}
      </div>
    </>
  )
}

Fixed.propTypes = {
  position:PropTypes.oneOf(["top", "bottom"]).isRequired,
  level:PropTypes.oneOf([1, 2]).isRequired
}

Fixed.defaultProps = {
  position:"top",
  level:1
}

export default Fixed